<div class="modal-header">
  <h4 class="modal-title">{{'WorkShiftMessage' | translate}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" style="overflow-y: unset;">

  <ng-template [ngIf]="loading"><div class="loadingScreen"></div></ng-template>
  <alert></alert>
  <form name="myForm" #myForm="ngForm" class="form-horizontal">
    <ng-template [ngIf]="isItANewWorkshiftRequest()"><div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>{{'ServiceDepartement' | translate}}</label>
            <!--
            <ngx-dropdown-treeview required
                                   [config] = "treeviewConfig"
                                   [items] = "treeviewItems"
                                   (selectedChange)="onSelectedChange($event)">
            </ngx-dropdown-treeview>
            -->

            <dropdownTree [selectLabelCode]="'PleaseSelectUnit'" [itemSelectedLabelCode]="'NbrSelectedUnit'" [items]="treeviewItems" (selectedChange)="onSelectedChange($event)">

            </dropdownTree>


          </div>

        </div>
        <div class="col">
          <div class="form-group">
            <label >{{'Job' | translate}}</label>
            <select required name="Job" class="form-control" id="Job" [(ngModel)]="content.jobId" (change)="onJobChange()">
              <option value="">&nbsp;</option>
              <!--<option *ngFor="let bean of jobs" [ngValue]="bean.job.jobId">{{bean.job.description}} | {{bean.job.jobLabel}}</option>-->
              <option *ngFor="let bean of jobs" [ngValue]="bean.job.jobId">{{bean.job.description}}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row" >
        <div class="col">
          <div class="form-group">
            <label >{{'WorkshiftRequestDate' | translate}}</label>
            <div class="input-group">
              <button class="input-group-addon" (click)="d.toggle()" type="button">
                <i class="emprez-duo-icon fad fa-calendar"></i>
              </button>
              <input required name="eventDate" class="form-control" placeholder="yyyy-mm-dd"
                     [ngModel]="content.eventDate | displayDateInUI" ngbDatepicker #d="ngbDatepicker" (ngModelChange)="content.eventDate = retrieveDate.transform($event)">
              <!--name="dp" [(ngModel)]="dob" ngbDatepicker #d="ngbDatepicker">-->
              <button class="input-group-addon" (click)="d.toggle()" type="button">
                <i class="emprez-duo-icon fad fa-calendar"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="form-group" >
            <label>{{'WorkshiftStartEndTime' | translate}}</label>
            <input required type="text" name="startEndWorkshiftTimeStr" class="form-control" validateStartEndTimeInterval [textMask]="{mask: maskStartEndTime}"  [(ngModel)] = "startEndWorkshiftTimeStr" >
          </div>
        </div>

      </div>


      <div class="row" >
        <div class="col">
          <div class="form-group">
            <label>{{'ServiceDepartement' | translate}}</label>
            <!--
            <ngx-dropdown-treeview
              [config] = "treeviewConfig2"
              [items] = "treeviewItems2"
              (selectedChange)="onSelectedChange2($event)">
            </ngx-dropdown-treeview>
            -->
            <dropdownTree [selectLabelCode]="'PleaseSelectUnit'" [itemSelectedLabelCode]="'NbrSelectedUnit'" [items]="treeviewItems2" (selectedChange)="onSelectedChange2($event)">

            </dropdownTree>

          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div style="display: inline-block; margin-bottom: 0.5rem;" class="space-icon">{{'Recipients' | translate}}
              <a class="naked emprez-duo-icon" (click)="selectAll()" [ngbTooltip]="'SelectAll' | translate" ><i class="fad fa-check-circle"></i>&nbsp;</a>
              <a class="naked emprez-duo-icon" (click)="unSelectAll()" [ngbTooltip]="'UnSelectAll' | translate"><i class="fad fa-times-circle"></i>&nbsp;</a>
              <input name="includeInactivePosition"  type="checkbox"  [(ngModel)]="includeInactivePosition" (change)="changeActiveInactivePosition()" > <span [ngbTooltip]="'IncludeInactivePositionTip' | translate">{{'IncludeInactivePosition' | translate}}</span>

            </div>
            <div>
<!--              <ss-multiselect-dropdown name="recipients" [options]="myRecipients" [texts]="myTexts" [settings]="mySettings" [(ngModel)]="optionsModel" ></ss-multiselect-dropdown>-->
              <multiSelectDropdown name="recipients2"
                                   [selectLabelCode]="'SelectRecipients'"
                                   [itemSelectedLabelCode]="'RecipientsSelected'" [noSelectionAvailableLabelCode]="'NoRecipientToSelect'"
                                   [nbSelectedMax]="2" [modelToSelectFrom]="myRecipients" [(ngModel)]="optionsModel"></multiSelectDropdown>

            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="form-group">
            <label >{{'note' | translate}}</label>
            <textarea name="note" required type="text" class="form-control" [(ngModel)]="content.note" ></textarea>
          </div>
        </div>
      </div>
    </div></ng-template>

    <ng-template [ngIf]="!isItANewWorkshiftRequest()"><div style="padding: 15px">
      <div [innerHtml] =explainApplication(data,content)></div>

    </div></ng-template>


  </form>


</div>

<ng-template [ngIf]="isItANewWorkshiftRequest()"><div class="modal-footer">
  <button type="button" class="btn btn-primary"  [disabled]="!myForm.form.valid || !isFormValid()" (click)="onSave()">{{'SaveAndSend' | translate}}</button>
  <button type="button" class="btn btn-secondary" (click)="onCancel()">{{'Cancel' | translate}}</button>
</div></ng-template>

<ng-template [ngIf]="!isItANewWorkshiftRequest()"><div class="modal-footer">
  <button type="button" class="btn btn-primary"  (click)="onAccept()">{{'Accept' | translate}}</button>
  <button type="button" class="btn btn-secondary" (click)="onReject()">{{'Reject' | translate}}</button>
</div></ng-template>
